/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.FameAdvantage {
    import Constants = Meevo.Components.Common.Constants;

    export class SettingsSection extends Meevo.Components.CommonClasses.CommonSectionBase {
        public model: IAdvantageSettings;
        public advantageStatusOptions = [
            {label: 'LABEL_ACTIVE', value: FameAdvantageStatusEnum.Active},
            {label: 'LABEL_DELETED', value: FameAdvantageStatusEnum.Deleted},
            {label: 'LABEL_INACTIVE', value: FameAdvantageStatusEnum.Inactive},
            {label: 'LABEL_TERMINATED', value: FameAdvantageStatusEnum.Terminated},
        ];
        public urlRegex = Constants.REGEX_URL;

        protected dataService: IFameAdvantageApi;

        private get testConnectionModel(): IAdvantageTestConnectModel {
            return {
                advantageAPIURL: this.model.advantageAPIURL,
                username: this.model.userName,
                password: this.model.password,
                tenantName: this.model.tenantName,
            };
        }

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: IFameAdvantageApi,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            sectionSecurityKey: string,
            private modalService: Meevo.Components.Modal.IModalService,
            private busyService: Meevo.Components.Busy.IBusyService,
        ) {
            super(
                sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                noun,
                identityService,
                sectionSecurityKey,
            );
        }


        public testConnection() {
            this.busyService.start();
            this.dataService.testConnection(this.testConnectionModel)
                .then((isSuccess: boolean) => {
                    this.busyService.stop();
                    if (isSuccess) {
                        this.modalService.message('MESSAGE_SUCCESSFUL_ADVANTAGE_CONNECT');
                    } else {
                        this.modalService.alert('MESSAGE_UNSUCCESSFUL_ADVANTAGE_CONNECT');
                    }
                });
        }
    }
}
